export enum BrightcoveErrorCode {
    MEDIA_ERR_DECODE = '3',
    MEDIA_ERR_SRC_NOT_SUPPORTED = '4',
    PLAYER_ERR_GEO_RESTRICTED = 'PLAYER_ERR_GEO_RESTRICTED',
}
